import { Atiba, ACO1, Iglu, FMCP, Blink, Secondlookortho, Academify, Massimomotor, Truckinlink } from "../../assets/index"

export const portfolioImagesOne = [
    {
        img: Atiba,
    },
    {
        img: ACO1,
    },
    {
        img: Iglu,
    },
    {
        img: Atiba,
    },
    {
        img: ACO1,
    },
    {
        img: Iglu,
    },
    {
        img: Atiba,
    },
]

export const portfolioImagesTwo = [
    {
        img: FMCP,
        title: "Ammar"
    },
    {
        img: Blink,
        title: "Ammar"
    },
    {
        img: Secondlookortho,
        title: "Ammar"
    },
    {
        img: FMCP,
        title: "Ammar"
    },
    {
        img: Blink,
        title: "Ammar"
    },
    {
        img: Secondlookortho,
        title: "Ammar"
    },
    {
        img: FMCP,
        title: "Ammar"
    },
]

export const portfolioImagesThree = [
    {
        img: Academify,
        title: "Ammar"
    },
    {
        img: Massimomotor,
        title: "Ammar"
    },
    {
        img: Truckinlink,
        title: "Ammar"
    },
    {
        img: Academify,
        title: "Ammar"
    },
    {
        img: Massimomotor,
        title: "Ammar"
    },
    {
        img: Truckinlink,
        title: "Ammar"
    },
    {
        img: Academify,
        title: "Ammar"
    },
]

export const mobileImages = [
    {
        img: Atiba,
        title: "Ammar"
    },
    {
        img: ACO1,
        title: "Ammar"
    },
    {
        img: Iglu,
        title: "Ammar"
    },    
    {
        img: FMCP,
        title: "Ammar"
    },
    {
        img: Blink,
        title: "Ammar"
    },
    {
        img: Secondlookortho,
        title: "Ammar"
    },
    {
        img: Academify,
        title: "Ammar"
    },
    {
        img: Massimomotor,
        title: "Ammar"
    },
    {
        img: Truckinlink,
        title: "Ammar"
    },
]